<template>
  <header class="customer-header">
    <div class="header-content maxW">
      <section class="content-left">
        <div class="catchword">{{ $t("customer.catchword") }}</div>
        <div class="phoneNumber" v-if="info_phone">
          <i class="el-icon-phone"></i>
          <div class="number">{{ info_phone }}</div>
        </div>
      </section>
      <section class="content-right">
        <div class="right-search">
          <div
            id="searchBar"
            :class="[searchBarFixed == true ? 'isfixed' : '']"
          >
            <div class="header-cont maxW clear">
              <!-- 头部搜索框 -->
              <div class="head-search fr">
                <template>
                  <el-select
                    style="width: 90px"
                    v-model="selectVal"
                    :placeholder="$t('global.choose')"
                  >
                    <el-option
                      v-for="item in selectOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>

                <i class="gery-line"></i>
                <el-input
                  :placeholder="$t('global.searchKeyword')"
                  v-model="keyWord"
                  class="input-with-select"
                  clearable
                  @keyup.enter.native="searchContent"
                >
                  <el-button
                    type="primary"
                    slot="append"
                    @click="searchContent"
                  >
                    <i class="el-icon-search"></i>
                  </el-button>
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="user-info">
          <el-popover
            popper-class="userinfo_popover"
            width="120"
            v-if="userId"
            placement="bottom-start"
            trigger="hover"
          >
            <p class="safe" @click="goToMedule(1)" v-if="managerole == true">
              <img src="../../../assets/images/v2/setting_icon.png" />
              {{ $t("homepage.manage") }}
            </p>
            <p
              class="safe"
              @click="goToPath('/setting')"
              v-if="!pathOption.notSetting"
            >
              <img src="../../../assets/images/v2/manage_icon.png" />
              {{ $t("homepage.settings") }}
            </p>
            <p
              class="safe"
              @click="dialogVisible = true"
              v-if="role.length > 1"
            >
              <img src="../../../assets/images/v2/setting_icon.png" />
              {{ $t("homepage.changeRole") }}
            </p>
            <div class="redDot" v-if="isRed"></div>
            <p class="safe studey_dot" @click="goToPath('/home/studyList')">
              <img src="../../../assets/images/v2/study_icon.png" />
              {{ $t("homepage.studyTest") }}
            </p>
            <p class="safe" @click="loginOut">
              <img src="../../../assets/images/v2/exit_icon.png" />
              {{ $t("homepage.loginOut") }}
            </p>
            <div slot="reference">
              <el-avatar size="small" :src="userInfo.avatar_path"></el-avatar>
              <div class="user-name">{{ userInfo.name }}</div>
            </div>
          </el-popover>

          <div class="plase-login" v-if="!userId" @click="loginOut">
            {{ $t("customer.pleaseLogin") }}
          </div>
        </div>
      </section>
    </div>
    <div class="header-logo" @click="handleClickLogo">
      <img
        :src="require('@/assets/images/customer/logo@2x.png')"
        alt="logo"
        :draggable="false"
      />
    </div>
    <!-- 切换身份弹窗 -->
    <el-dialog
      :title="$t('homepage.changeRole')"
      class="common-dialog identity-dialog"
      width="400px"
      :visible.sync="dialogVisible"
    >
      <div>
        <ul class="role-ul">
          <li
            v-for="(item, index) in userInfo.role"
            :key="index"
            @click="checkRole = item"
          >
            <span class="role-icon">
              <i v-if="item == 6" class="ipng icon_guanliyuan"></i>
              <i v-else-if="item == 5" class="ipng icon_guanliyuan"></i>
              <i v-else class="ipng icon_guanliyuan"></i>
              <i v-show="checkRole == item" class="ipng Select01"></i>
            </span>
            <span class="rolename">{{ userInfo.rolename[index] }}</span>
          </li>
        </ul>
      </div>
      <div class="foot-btns">
        <el-button @click="dialogVisible = false">{{
          $t("global.cancel")
        }}</el-button>
        <el-button type="primary" @click="changeRole">{{
          $t("global.sure")
        }}</el-button>
      </div>
    </el-dialog>
  </header>
</template>

<script>
import { fail } from "assert";
// import { map } from 'vuex'
export default {
  props: {
    pathOption: {
      personal: "", //个人中心跳转路径
      manage: "", //后台跳转路径
      notSetting: "", // 不显示账号设置
    },
    info_phone: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isRed: false,
      searchText: "",
      jumpPage: "",
      // 学校多级参数，跳前台模块或者跳个人中心的时候带上
      CheckSchoolAppCode:
        this.$route.query.CheckSchoolAppCode == undefined
          ? "00000000000000000000000000000000"
          : this.$route.query.CheckSchoolAppCode,
      logo_url: "", //logo地址
      activeInx: "0", //菜单栏高亮默认选中第一个
      headMenuData: [], //菜单栏数据
      activeArr: [], // 存放headMenuData的url属性
      keyWord: "", //搜索输入的关键字
      selectVal: "1", //搜索框左侧下拉标题选中的索引
      searchBarFixed: false, //是否固定在顶部的判断
      loginData: {}, //登录用户的所有信息
      userId: 0, //用户id
      // userInfo: {}, //用户身份信息
      role: [], //身份id数组
      dialogVisible: false, //切换身份弹窗
      checkRole: null, //当前的身份
      isTeacher: 0, //是否是老师
      teacherAuthority: 0, //教师权限（一般情况下管理员拥有教师权限）
      managerole: false, //后台权限
      personalFlag: false, //个人中心权限
      messageFlag: false, //我的消息
      messageCount: 0, //我的消息数量
      isVistor: 0, //是否是游客
      casFlag: false, //是否是单点登录
      login_out: "",
      scrollHandler: null, //页面滚动触发器
      loginOutHost: "", //单点登录退出的地址
      langData: [
        {
          label: "中 文",
          value: "zh-cn",
        },
        {
          label: "中文繁体",
          value: "zh-hk",
        },
        {
          label: "英 文",
          value: "en-us",
        },
      ],
    };
  },
  created() {
    this.getLogo();
    this.getHeadMenu();
    this.checkCas();
    this.getRed();
    this.getActiveIndex();
  },
  mounted() {
    this.$nextTick(function () {
      this.messageUnread();
      this.checkLogin();
    });
    this.loginOutHost = sessionStorage.getItem("host_addr");
    //页面下滚，顶部导航栏吸顶。此处通过原生js监听scroll的高度如果超过导航条长度103px就出发吸顶，
    //但是频繁触发scoll resize这类事件都是很耗费性能的，此处调用debounce函数对scroll事件进行延迟处理，设定时间仅调用最后一次，
    //这样页解决了不断的上下滚动页面时，页面出现上下抖动的问题。
    this.scrollHandler = this.debounce(() => {
      this.handleScroll();
    }, 100);
    // window.addEventListener("scroll", this.scrollHandler);

    // 根据地址栏是有关键字参数的，判断是否在页面刷新时，把之前的数据重新展示
    if (this.$route.query.keyword == undefined) {
      this.selectVal = "1";
      this.keyWord = "";
      sessionStorage.setItem("selectVal", "1");
    } else {
      this.selectVal = sessionStorage.getItem("selectVal");
      this.keyWord = this.$route.query.keyword;
    }
    // 页面刷新，判断菜单选中高亮效果
    // this.changeRoute();
  },
  watch: {
    // 路由变化的时候，也切换菜单选中高亮效果
    $route(to, from) {
      if (to != from) {
        // this.changeRoute();
      }
    },
  },
  computed: {
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") == 1; // 是否为腾讯云平台
    },
    langTxt() {
      let item = this.langData.filter((x) => x.value === this.$i18n.locale);
      return item[0].label;
    },
    userInfo() {
      //此处修改方便账号设置修改信息后，页面头部信息也同步修改
      let userInfo = this.$store.getters.userInfo;
      if (userInfo.first_login === 1 && this.isTencentCloud) {
        this.loginOut();
      }
      if (!userInfo.avatar_path) return userInfo;
      if (
        userInfo.avatar_path.includes("/static/default/user_preview-1.png") ||
        userInfo.avatar_path.includes("/public/picture")
      ) {
        if (!userInfo.avatar_path.includes("http")) {
          userInfo.avatar_path = this.BASE_URL + userInfo.avatar_path;
        }
      }
      return userInfo;
      // const data = JSON.parse(sessionStorage.getItem("user_info_str"));
      // console.log('xxxx')
      // return data ? data : {};
    },
    selectOptions() {
      return [
        //搜索框左侧下拉标题数组
        // {
        //     value: "1",
        //     label: '首页',
        // },
        {
          value: "1",
          label: "课程中心",
        },
        {
          value: "2",
          label: "高层讲堂",
        },
        {
          value: "3",
          label: "训练营",
        },
        {
          value: "4",
          label: "百万大单",
        },
        {
          value: "5",
          label: "资源中心",
        },
      ];
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandler); //移除页面滚动事件的监听
  },
  methods: {
    handleClickLogo() {
      window.sessionStorage.setItem("activeIndex", 0);
      this.$router.push("/homeindex");
      this.$store.commit("SET_ACTIVEINDEX", 0);
    },

    // 获取红点
    getRed() {
      if (this.$g.user_id) {
        let success = (res) => {
          this.isRed = Array.isArray(res.data) ? false : true;
        };
        this.$ajax.get("/api/assignment/getIsUpdate", {
          // type 1：任务指派；2：成长地图
          params: { type: 1, user_id: this.$g.user_id },
          func: { success: success },
        });
      }
    },
    goToPath(path) {
      if (path === "/home/studyList") {
        sessionStorage.setItem("activeMenu", "1");
      }
      this.$router.push(path);
    },
    getActiveIndex() {
      this.activeInx = is_empty(sessionStorage.getItem("activeInx"))
        ? "0"
        : sessionStorage.getItem("activeInx");
    },
    // 根据路由地址设置菜单高亮
    // changeRoute() {
    // 	// console.log('路由名称',this.$route.meta.activeName)
    // 	// let active = this.$route.meta.activeInx;
    // 	let active = this.$route.meta.activeName;
    // 	// console.log(active)
    // 	let arr = this.activeArr;
    // 	// // console.log('arr', arr)
    // 	// arr.forEach(element => {
    // 	// 	// console.log(element)
    // 	// });
    // 	// for (let i = 0; i < arr.length; i++) {
    // 	// 	if (active == arr[i]) {
    // 	// 		active = i;
    // 	// 		break;
    // 	// 	} else if (arr[i].includes(active)) {
    // 	// 		active = i;
    // 	// 		break;
    // 	// 	}
    // 	// }
    // 	// this.activeInx = '' + active;
    // 	// sessionStorage.setItem("selectVal", active);
    // },
    // 判断当前是否单点登录跳
    checkCas() {
      let success = (res) => {
        if (res.data == "yes") {
          this.casFlag = true;
        } else {
          this.casFlag = false;
        }
      };
      this.$ajax.get("api/login/get_use_single_login", {
        params: {},
        func: {
          success: success,
        },
      });
    },
    // 跳转到登录页
    goToLogin() {
      // 待完善，如果商学院不需要登录的话，这样做会无法获取场景模式
      this.$router.push("/user-login");
    },
    //页面向下滚动的时候，搜索栏吸顶事件
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // var offsetTop = document.querySelector("#searchBar").offsetTop;
      if (scrollTop > 103) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
    //延迟处理
    debounce(func, wait, immediate) {
      let timeout, args, context, timestamp, result;
      const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp;

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          // 如果设定为immediate===true，因为开始已经调用过了此处无需调用
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) context = args = null;
          }
        }
      };
      return function (...args) {
        context = this;
        timestamp = +new Date();
        const callNow = immediate && !timeout;
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }

        return result;
      };
    },

    // 获取页面头部菜单栏的数据
    getHeadMenu() {
      let success = (res) => {
        // 2022/8/9 跳转路径为数组第一个
        // this.headMenuData[0].url = "/home"
        // console.log('headMenuData', this.headMenuData)
        // 由于后台返回的模块地址，和现在前台的模块路径不一样，所以修改一下
        let dataArr = res.data;
        // dataArr.forEach((item,index) => {
        // 	if(item.name == '课程专辑'){
        // 		let album =  dataArr[index]
        // 		dataArr.splice(dataArr.length-1)
        // 		dataArr.splice(3, 0, album)
        // 	}
        // });
        // this.changeUrl(dataArr, "1", "/home");
        // this.changeUrl(dataArr, "2", "/home/resource", "/home/resource", "/home/resourceList");
        // // this.changeUrl(dataArr, "6", "/home/course", "/home/course", "/home/liveList", "/home/openclassList");
        // this.changeUrl(dataArr, "6", "/home/albumList", "/home/albumDetail", "/home/albumPaper");
        // this.changeUrl(dataArr, "10", "/home/app");
        this.activeArr = dataArr.map((item) => item.url);
        if (res.data[0].url == "/") {
          res.data[0].url = "/homeindex";
        }
        this.headMenuData = res.data;
        this.jumpPage = res.data[0].url;
        // // console.log(JSON.parse(JSON.stringify(dataArr)),'dataArr',this.activeArr)
        // this.changeRoute();
      };
      this.$ajax.get("api/system/get_home_menu_cansee", {
        params: {},
        func: {
          success: success,
        },
      });
    },
    /***
     * 修改菜单栏跳转地址
     * arr菜单数据
     * 父级菜单id和地址 pid pUrl
     * 子级菜单地址 cUrl1 cUrl2 cUrl3
     *
     */
    changeUrl(arr, pid, pUrl, cUrl1, cUrl2, cUrl3) {
      // console.log(arr, pid, pUrl, cUrl1, cUrl2, cUrl3, 666)
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].is_default == 1 && arr[i].id == pid) {
          arr[i].url = pUrl;
          if (!is_empty(arr[i].children)) {
            if (arr[i].children[0] != undefined) {
              arr[i].children[0].url = cUrl1;
            }
            if (arr[i].children[1] != undefined) {
              arr[i].children[1].url = cUrl2;
            }
            if (arr[i].children[2] != undefined) {
              arr[i].children[2].url = cUrl3;
            }
          }
        } else if (arr[i].id == pid) {
          arr[i].url = pUrl;
        }
      }
    },
    // 菜单栏点击事件
    selectMenuTab(inx, keyPath) {
      console.log("here,sir", inx);
      this.activeInx = inx + "";
      sessionStorage.setItem("activeInx", inx + "");
      // // 点击菜单选项时，若搜索栏有搜索内容，则清掉
      if (this.keyWord != "") {
        this.selectVal = "1";
        this.keyWord = "";
        sessionStorage.setItem("selectVal", "1");
      }
    },

    // 点击logo事件
    pageHome() {
      // console.log('点击logo',sessionStorage.getItem("host_addr"))
      this.$router.push(this.jumpPage);
      this.activeInx = "0";
      // console.log('点击logo',this.jumpPage)
    },
    //获取logo
    getLogo() {
      let success = (res) => {
        this.logo_url = res.data[0].f_logo;
      };
      this.$ajax({
        url: "api/system/get_logo",
        method: "get",
        params: {},
        func: {
          success: success,
        },
      });
    },

    // hover用户头像弹窗里面的跳转
    goToMedule(module) {
      switch (module) {
        // 跳去管理中心
        case 1:
          window.location.href = this.pathOption.manage;
          break;
        // 跳去个人中心的我的消息
        case 2:
          window.location.href =
            this.pathOption.personal + "&routerUrl=message";
          break;
        // 跳去个人中心
        case 3:
          window.location.href = this.pathOption.personal;
          break;
        // 跳去个人个人档案（针对学生身份）
        case 4:
          this.checkUrl("schoolroll");
          break;
      }
    },
    // 检验是否有跳转到前台某个模块的权限
    checkUrl(url) {
      let success = (res) => {
        this.$router.push("/" + url);
      };
      this.$ajax.get("/api/login/checkthisnode", {
        params: {
          url: url,
          token: localStorage.getItem("token"),
          checkschoolappcode: this.CheckSchoolAppCode,
        },
        func: {
          success: success,
        },
      });
    },
    // 退出登录
    loginOut() {
      let success = (res) => {
        if (this.casFlag == false) {
          this.$message.closeAll();
          this.$message.success("退出成功");
          this.$store.commit("SET_ACTIVEINDEX", 0);
          localStorage.removeItem("token");
          sessionStorage.removeItem("user_info_str");
          this.$router.push("/user-login");

          // sessionStorage.clear();
          // localStorage.clear();
          // window.location.href = location?.origin + '/user-login';

          // 场景获取放在读取页面，所以如下改动
          // window.location.href = location?.origin || this.loginOutHost;
        } else {
          sessionStorage.clear();
          localStorage.clear();
          // window.location.href = this.login_out + '/user-login';

          // 场景获取放在读取页面，所以如下改动
          window.location.href = this.login_out;
        }
      };
      this.$ajax({
        url: "api/login/login",
        method: "delete",
        params: {},
        func: {
          success: success,
        },
      });
    },
    // 搜索按钮点击事件：（页头搜索框+跳转）
    searchContent() {
      // console.log("点击了-----------");
      // 当点击的时候，把选中跳转模块的值缓存
      sessionStorage.setItem("selectVal", this.selectVal);
      // 构建即将跳转的路由对象
      const routeData = {
        path: "",
        query: {
          keyword: this.keyWord,
        },
      };

      switch (this.selectVal) {
        case "1":
          routeData.path = "/home/openclassList";
          break;
        case "2":
          routeData.path = "/home/leaderList";
          break;
        case "3":
          routeData.path = "/home/albumList";
          break;
        case "4":
          routeData.path = "/home/bigorderList";
          break;
        case "5":
          routeData.path = "/home/resourceList";
          break;
      }

      // 检查即将导航的路由是否与当前路由相同
      if (
        this.$route.path === routeData.path &&
        this.$route.query.keyword === this.keyWord
      ) {
        console.log("已经在当前路由，无需重复导航");
      } else {
        this.$router.push(routeData).catch((err) => {
          // 如果是NavigationDuplicated错误，可以忽略
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
      }
    },
    //查询登录情况
    checkLogin() {
      // console.log( '链接111')
      let success = (data) => {
        this.loginData = data.data;
        sessionStorage.setItem(
          "user_info_str",
          JSON.stringify(deep_clone(data.data.userinfo))
        );
        this.$store.commit("SET_USERINFO", data.data.userinfo);
        // this.userInfo = data.data.userinfo; //用户信息

        this.userId = data.data.userinfo.id;
        this.checkRole = data.data.userinfo.check_role; //当前登录状态是什么身份
        this.role = data.data.userinfo.role; //身份id数组
        this.isTeacher = data.data.userinfo.thisLoginUserIsTeacher; //判断是不是老师
        this.teacherAuthority = data.data.userinfo.thisLoginUserIsTeachertrue; //教师权限
        this.login_out = data.data.logout_url;
        if (data.data.userinfo) {
          localStorage.setItem("userType", data.data.userinfo.type);
          if (data.data.userinfo.type === 2) {
            this.$router.push("/customer-home");
          }
        }

        //后台权限
        if (
          typeof data.data.manage != "undefined" &&
          data.data.manage != null &&
          data.data.manage != ""
        ) {
          this.managerole = true;
        } else {
          this.managerole = false;
        }
        // 个人中心权限、我的消息显示
        if (typeof data.data.personal != "undefined") {
          this.personalFlag = true;
          var has_message = 0;
          for (let i = 0; i < data.data.node_personal.length; i++) {
            if (data.data.node_personal[i].name == "message") {
              has_message = 1;
            }
          }
          if (has_message == 1) {
            this.messageFlag = true;
          } else {
            this.messageFlag = false;
          }
        } else {
          this.messageFlag = false;
        }

        //是否是游客
        this.isVistor = data.data.userinfo.is_youke;
        // if (data.data.userinfo.is_youke == 1) {
        //   this.managerole = false;
        //   this.personalFlag = false;
        // }
        this.globalMessage(); //WebSocket获取全局信息提示
      };
      let fail = (data) => {
        this.userId = 0;
        this.$router.push({ path: "/user-login" });
      };
      this.$ajax({
        url: "api/login/login",
        method: "get",
        params: {},
        func: {
          success: success,
          fail: fail,
        },
      });
    },

    //切换身份弹窗的确定按钮
    changeRole() {
      let success = (data) => {
        this.checkLogin();
        this.dialogVisible = false;
        this.$message.success(data.msg);
      };
      this.$ajax({
        url: "/api/login/check_login_section",
        method: "put",
        data: {
          check_role: this.checkRole,
        },
        func: {
          success: success,
        },
      });
    },
    // 我的消息未读数量
    messageUnread() {
      //是否登录
      if (this.userInfo.id == 0) {
        return false;
      }
      let success = (res) => {
        let count = 0;
        for (let i = 0; i < res.data.length; i++) {
          count += parseInt(res.data[i].num);
        }
        this.messageCount = count;
      };
      this.$ajax({
        url: "api/message/message_unread_count",
        method: "get",
        params: {},
        func: {
          success: success,
        },
      });
    },
    //全局消息
    globalMessage() {
      //是否登录
      if (this.userInfo.id == 0) {
        return;
      }
      let webSocketURL;
      //登录连接后台socket接收消息
      if (Number(this.isTencentCloud)) {
        webSocketURL = "wss:" + this.BASE_URL.split(":")[1] + ":7575";
      } else {
        webSocketURL = "ws:" + this.BASE_URL.split(":")[1] + ":7575";
      }
      var wss = new WebSocket(webSocketURL);
      wss.onopen = () => {
        var message = JSON.stringify({
          type: "login",
          user_id: this.userInfo.id,
        });
        wss.send(message);
        // console.log("已连接上...,发送身份信息：" + message);
      };
      wss.onmessage = (evt) => {
        var data = JSON.parse(evt.data);
        let that = this;
        that.$notify({
          title: "【" + data.content_type + "】",
          message: data.title,
          duration: 3000,
          offset: 130,
          //全局信息点击事件
          onClick: function () {
            that.globalMessageType = data.global_message_type;
            if (
              data.global_message_type == "notice" ||
              data.global_message_type == "comment"
            ) {
              that.globalNoticeMessageCheckLook(
                data.id,
                data.type,
                data.template,
                data.content_id,
                data.module
              );
            }
          },
        });
        this.messageUnread();
        // console.log("数据已接收...:", data);
      };
      wss.onclose = function () {
        // 关闭 websocket
        // console.log("连接已关闭...");
      };
    },
    /**全局消息通知查看转发
     * @param id 自增id
     * @param type 消息内容类型（1：消息；2：班级通知；3：动态；4：收到的评论；5：发起的評論）
     * @param template 模板对应index  0:不使用模板
     * @param contentId 内容id
     * @param moduleVal 所属模块
     */
    globalNoticeMessageCheckLook(id, type, template, contentId, moduleVal) {
      // console.log(id, type, template, contentId, moduleVal)
      if (parseInt(type) == 1) {
        this.noticeCheckLook(template, contentId, moduleVal);
      } else if (parseInt(type) === 2) {
        this.followCheckLook(template, contentId, moduleVal);
      } else if (parseInt(type) === 3) {
        this.groupCheckLook(template, contentId, moduleVal);
      } else if (parseInt(type) === 4) {
        this.globalCommentMessageCheckLook(contentId, moduleVal);
      }
    },
    // 跳个人中心相关的模块
    linkToPresonalModule(moduleUrl) {
      let urlString = this.pathOption.personal + "&routerUrl=" + moduleUrl;
      window.open(urlString, "_blank");
    },
    //全局消息通知跳转
    noticeCheckLook(template, contentId, moduleVal) {
      // console.log(template, contentId, moduleVal)
      //班级通知->个人中心班级通知
      if (template === "0" && moduleVal == "class") {
        this.linkToPresonalModule("notice");
      }
      //请假->个人中心请假
      else if (moduleVal == "leave") {
        this.linkToPresonalModule("leave");
      }
      //班级任务->个人中心班级任务
      else if (moduleVal == "task") {
        this.linkToPresonalModule("homework");
      }
      //直播
      else if (moduleVal == "live") {
        let success = (res) => {
          if (data.data.role_id.indexOf(1) > -1) {
            this.linkToPresonalModule("/teach/live/listlive");
          } else {
            this.$router.push({
              path: "/home/liveRoom",
              query: {
                id: contentId,
              },
            });
          }
        };
        this.$ajax({
          url: "/api/user/user_info",
          method: "get",
          params: {
            id: this.userInfo.id,
            level: 2,
          },
          func: {
            success: success,
          },
        });
      }
      //问答
      else if (moduleVal == "question") {
        if (template === "question_1") {
          this.linkToPresonalModule("/teach/ask/index");
        } else if (template === "question_2") {
          this.$router.push({
            path: "/home/openclassDetail",
            query: {
              id: contentId,
            },
          });
        }
      }
      //备课
      else if (moduleVal == "prepare") {
        this.$router.push({
          path: "/prepare/edit",
          query: {
            id: contentId,
          },
        });
      }
      //跳去邮件
      else if (moduleVal == "email") {
        this.$router.push({
          path: "/email/inbox#id=" + contentId,
        });
      }
    },
    //全局消息关注跳转
    followCheckLook(template, contentId, moduleVal) {
      if (moduleVal == "resource") {
        this.$router.push({
          path: "/home/resourceDetail",
          query: {
            id: contentId,
          },
        });
      } else if (moduleVal == "live") {
        this.$router.push({
          path: "/home/liveRoom",
          query: {
            id: contentId,
          },
        });
      } else if (moduleVal == "video") {
        this.$router.push({
          path: "/home/openclassDetail",
          query: {
            id: contentId,
          },
        });
      }
    },
    //全局消息圈组跳转
    groupCheckLook(template, contentId, moduleVal) {
      if (
        template == "group_0" ||
        template == "group_1" ||
        template == "group_3"
      ) {
        this.$router.push({
          path: "/group/introduct",
          query: {
            id: contentId,
          },
        });
      } else if (template == "group_4" || template == "group_2") {
        this.$router.push("/group/manage/selfCreated");
      }
    },
    //全局消息评论跳转
    globalCommentMessageCheckLook(contentId, moduleVal) {
      // console.info(contentId, moduleVal)
      //公开课评论跳转
      if (parseInt(moduleVal) === 0) {
        this.$router.push({
          path: "/home/openclassDetail",
          query: {
            id: contentId,
          },
        });
      }
      // //资源评论跳转
      else if (parseInt(moduleVal) === 1) {
        this.$router.push({
          path: "/home/resourceDetail",
          query: {
            id: contentId,
          },
        });
      }
    },
    // 设置语言
    setLang(lang) {
      let success = (res) => {
        this.$i18n.locale = lang;
        this.$message.success(res.msg);
      };
      this.$ajax.get("api/login/change_lang", {
        params: {
          default_lang: lang,
        },
        func: { success: success },
      });
    },
    goHref(url) {
      window.location = url;
    },
  },
};
</script>

<style lang='scss'>
:deep(.is-focus) {
  border-color: #e62125;
}

.el-popover {
  min-width: 150px !important;
}

.avatar-img {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  vertical-align: middle;

  img {
    width: 100%;
    height: 100%;
  }
}

.userinfo_popover {
  padding: 0 !important;

  .safe {
    text-align: start !important;

    img {
      margin-left: 17px;
      margin-right: 11px;
    }
  }
}

.customer-header {
  user-select: none;
  width: 100%;
  height: 4rem;
  background-color: #2c2e3f;
  position: relative;
  border-bottom: #e62126 solid 2px;

  .header-content {
    height: 100%;
    line-height: 4rem;
    display: flex;
    justify-content: space-between;

    .content-left {
      color: #fff;
      display: flex;

      .catchword {
        margin-right: 3rem;
        font-size: 1.8rem;
      }

      .phoneNumber {
        display: flex;
        width: 10rem;
        align-items: center;

        i {
          font-size: 1.5rem;
        }

        .number {
          margin-left: 0.4rem;

          :deep(.el-skeleton__item) {
            width: 10rem;
            position: relative;
            top: 4px;
          }
        }
      }
    }

    .content-right {
      display: flex;

      .right-search {
        :deep(.el-input__inner:focus) {
          border-color: red;
        }

        :deep(.el-input-group__append) {
          border: none;
          background-color: #e62126;
          color: #fff;

          .el-icon-search {
            color: #fff;
            font-size: 1.5rem;
          }
        }
      }

      .el-popover__reference {
        display: flex;
        align-items: center;
      }

      .user-info {
        color: #fff;
        margin-left: 2rem;
        display: flex;
        align-items: center;
        position: relative;

        .el-avatar {
          margin-right: 1rem;
          width: 30px;
          height: 30px;
        }

        .user-name {
          max-width: 9rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
        }

        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  .header-logo {
    z-index: 110;
    position: absolute;
    top: 0;
    left: calc(50% - 80px);

    img {
      height: 160px;
      width: 160px;
    }
  }
}

.el-popover {
  .studey_dot {
    position: relative;
  }
  .redDot {
    width: 7px;
    height: 7px;
    border-radius: 30px;
    background-color: #e62126;
    position: absolute;
    left: 10px;
    z-index: 999;
  }

  .safe {
    width: 100%;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    margin: auto;
    display: inline-block;
  }

  img {
    vertical-align: middle;
    width: 28px;
    height: 28px;
  }

  .safe:hover {
    color: #e62125;
    background-color: #ffdbe4;
  }
}

.header-cont {
  // height: 48px;
  // line-height: 48px;
  // padding: 26px 0 26px;
  position: relative;

  .head-search {
    position: relative;
    width: 320px;

    .el-select {
      position: absolute;
      top: 0;
      left: 2px;
      z-index: 50;

      :deep(.el-input--medium .el-input__inner) {
        border: none;
      }

      :deep(.el-input) {
        width: 100px;
        height: 36px;
      }

      .el-input__inner {
        // padding: 0 20px 0 8px;
        border: 1px solid transparent;
        background: transparent;
        text-align: start;
        padding-left: 5px !important;
        padding-right: 0px;
        color: #333333;
        border-radius: 0;
      }

      .el-input__suffix {
        top: -1px !important;
      }

      .el-input__suffix
        .el-input__suffix-inner
        .el-select__caret.el-input__icon.el-icon-arrow-up {
        color: #333333;
      }

      .el-input__icon {
        width: 14px;
      }

      .el-icon-arrow-up:before {
        // content: "\E78F";
      }
    }

    .input-with-select.el-input.el-input-group.el-input-group--append.el-input--suffix
      .el-input-group__append {
      background-color: #e62126;
      border: 1px solid #e62126;
    }

    .gery-line {
      display: block;
      height: 16px;
      position: absolute;
      top: 17px;
      left: 95px;
      z-index: 50;
      border-left: 1px solid #e0e0e0;
    }

    :deep(.el-input-group--append .el-input__inner) {
      padding-left: 120px !important;
      height: 40px;
    }

    .input-with-select {
      .el-input__inner {
        // padding: 0 25px 0 90px;
        height: 35px;
        padding-left: 105px;
      }

      .el-input-group__append {
        position: relative;
        top: 0px;
        padding: 0 20px;
        color: #fff;
        background-color: #ffdbe4;
        border: 1px solid #ffdbe4;
        border-radius: 0 4px 4px 0;

        .search-icon {
          transform: scale(1.4);
          background-position: -26px -812px;
          width: 16px;
          height: 17px;
          background-image: url("../../../../public/images/ipng.png");
          background-repeat: no-repeat;
          display: inline-block;
          vertical-align: top;
        }
      }
    }
  }
}

.isfixed {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  z-index: 999;

  .header-cont {
    padding: 10px 0;
  }
}
</style>
